import { GateGuestDTO } from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'ContactTab',
  props: {
    editingGuest: {
      type: Object as PropType<GateGuestDTO>,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['contact-edited', 'error-contact'],
})
export default class ContactTab extends Vue {
  editingGuest!: GateGuestDTO;
  isEdit!: boolean;
  disabled!: boolean;
  valid = true;
  readonly descriptionMaxLength = 25;
  noModification = new GateGuestDTO();
  
  mounted() {
    this.noModification = new GateGuestDTO({...this.editingGuest});
  }

  namingValid() {
    return !!this.editingGuest.description && this.editingGuest.description.trim() !== '';
  }

  guestWasEdited() {
    this.valid = this.namingValid();
    this.$emit('error-contact', !this.valid);
    this.$emit('contact-edited', this.contactEdited());
  }

  contactEdited() {
    return this.editingGuest.description !== this.noModification.description && this.valid;
  }
}
